import { supabase } from '@/integrations/supabase/client';

export interface MeuPerfilCompleto {
  id: string;
  nome: string;
  role: string;
  telefone: string | null;
  cidade: string | null;
  estado: string | null;
  cpf: string | null;
  pix: string | null;
}

/** Busca o perfil completo do usuário logado (campos editáveis + role para exibição) */
export async function buscarMeuPerfil(userId: string): Promise<MeuPerfilCompleto | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, nome, role, telefone, cidade, estado, cpf, pix')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('Erro ao buscar perfil:', error);
    throw new Error(error.message || 'Erro ao buscar perfil');
  }

  if (!data) return null;

  return {
    id: data.id,
    nome: data.nome ?? '',
    role: data.role ?? 'user',
    telefone: data.telefone ?? null,
    cidade: data.cidade ?? null,
    estado: data.estado ?? null,
    cpf: data.cpf ?? null,
    pix: data.pix ?? null,
  };
}

/** Dados que o usuário pode alterar no próprio perfil (sem role, ativo, vendedor_id) */
export interface MeuPerfilUpdateData {
  nome?: string;
  telefone?: string | null;
  cidade?: string | null;
  estado?: string | null;
  cpf?: string | null;
  pix?: string | null;
}

/**
 * Atualiza o perfil do usuário logado. Permite apenas alterar dados cadastrais.
 * O tipo de perfil (role) NÃO pode ser alterado - isso é exclusivo do admin.
 */
export async function atualizarMeuPerfil(userId: string, data: MeuPerfilUpdateData): Promise<void> {
  const update: Record<string, unknown> = {};
  if (data.nome !== undefined) update.nome = data.nome;
  if (data.telefone !== undefined) update.telefone = data.telefone || null;
  if (data.cidade !== undefined) update.cidade = data.cidade ?? null;
  if (data.estado !== undefined) update.estado = data.estado ?? null;
  if (data.cpf !== undefined) update.cpf = data.cpf ?? null;
  if (data.pix !== undefined) update.pix = data.pix ?? null;

  const { error } = await supabase
    .from('profiles')
    .update(update)
    .eq('id', userId);

  if (error) {
    console.error('Erro ao atualizar perfil:', error);
    throw new Error(error.message || 'Erro ao atualizar perfil');
  }
}
